import React, { useEffect, useRef } from 'react'
import { Switch, Route } from 'react-router-dom'

import { Navbar, initializeAnalytics } from '@offerzen/pinata'

import CookieAcceptBanner from './components/CookieAcceptBanner'
import TermsLanding from './scenes/TermsLanding'
import CandidateTerms from './scenes/CandidateTerms'
import EmployerTerms from './scenes/EmployerTerms'
import EmployerSignTerms from './scenes/EmployerSignTerms'
import Footer from './components/Footer'

import './styles'

const TermsMain = () => {
  const analyticsInitialised = useRef(false)

  useEffect(() => {
    if (!analyticsInitialised.current) {
      initializeAnalytics(process.env.REACT_APP_SEGMENT_WRITE_KEY)
      analyticsInitialised.current = true
    }
  }, [analyticsInitialised])

  return (
    <>
      <CookieAcceptBanner />
      <Navbar />
      <main>
        <Switch>
          <Route exact path="/terms" component={TermsLanding} />
          <Route exact path="/terms/employer" component={EmployerTerms} />
          <Route exact path="/terms/employer-sign" component={EmployerSignTerms} />
          <Route exact path="/terms/candidate" component={CandidateTerms} />
        </Switch>
      </main>
      <Footer />
    </>
  )
}

export default TermsMain
